<p-toast></p-toast>
<!-- <div class="grid">
    <div class="col-12">
        <p-toolbar [style]="{
            'border-top-left-radius': '0px',
            'border-top-right-radius': '0px',
            'padding-bottom': '0px',
            'display': 'flex',
            'flex-wrap': 'wrap',
            'justify-content': 'space-between'
        }">
            <ng-template pTemplate="left">
                <div class="p-fluid">
                    <div class="p-formgrid grid p-3">
                        <div class="field">
                            <p-dropdown appendTo="body" class="custom-dropdown-one" optionLabel="fullName"
                                *authorityShow="['Attendance Daily (Full Access)']" [(ngModel)]="studentSearchID"
                                filterBy="fullName" [options]="studentSearchList" optionValue="id" (onFilter)="filterStudent($event)"
                                [filter]="true" [placeholder]="'Select Student'" (onChange)="searchStudent()" #studentNameDropdown>
                            </p-dropdown>
                        </div>
                        <div class="field textInp">
                            <input pInputText id="email2" [(ngModel)]="selectedDate" (ngModelChange)="handleDateChange($event)"
                                placeholder="Date" type="date" />
                        </div>
                        <div class="field">
                            <p-dropdown appendTo="body" class="custom-dropdown-one" optionLabel="name"
                                *authorityShow="['Attendance Daily (Full Access)']" [(ngModel)]="searchedListRoomId"
                                filterBy="name" [options]="roomsList" optionValue="id" (onFilter)="filterRoom($event)"
                                [filter]="true" [placeholder]="'Select Classroom'" (onChange)="searchStudent()" #roomNameDropdown>
                            </p-dropdown>
                        </div>
                        <div class="field icon-reset mt-1" *authorityHide="['Parent Is Private (Full Access)']">
                            <button type="button" pButton pRipple (click)="clearForm()" label="Clear"
                                class="p-button-secondary p-button-sm"></button>
                        </div>
                        <div class="field icon-reset mt-1" *authorityShow="['Parent Is Private (Full Access)']">
                            <button type="button" pButton pRipple (click)="clearForm()" label="Clear"
                                class="p-button-secondary p-button-sm"></button>
                         </div>       
                    </div>
                </div>
            </ng-template>
        
            <ng-template pTemplate="right">
                <div class="assign-btn">
                    <button pButton pRipple label="Sign-In" type="button" class="p-button-primary addbtn"
                        *authorityShow="['Attendance Daily (Full Access)','Parent Is Private (Full Access)']"
                        (click)="signIn()" icon="pi pi-sign-in" [disabled]="this.selectedStudents.length == 0"></button>
                </div>
            </ng-template>
        </p-toolbar>
        
        <div class="row gap-3" *ngIf="selectedStudents.length > 0"
            style="margin-left: 10px; margin-top: 10px; margin-bottom: 10px">
            <div *ngIf="selectedStudents.length > 0">
                {{
                selectedStudents.length === 1
                ? selectedStudents.length + " Student Selected"
                : selectedStudents.length + " Students Selected"
                }}
            </div>
        </div>

        <p-table #dt [value]="studentList" [(selection)]="selectedStudents" [lazy]="true" (onLazyLoad)="loadStudent($event)"
            dataKey="id" [tableStyle]="{ 'min-width': '50rem' }" [paginator]="true" [rows]="10"
            [totalRecords]="pageContext.totalItems" [rowsPerPageOptions]="[10,25, 50]" [loading]="loading"
            [showCurrentPageReport]="true" currentPageReportTemplate="Showing {{
                    pageContext.totalItems > 0 ? first + 1 : first
                }} to {{ last }} of {{ pageContext.totalItems }} entries">
            <ng-template pTemplate="header">
                <tr>
                    <th style="width: 4rem">
                        <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                    </th>
                    <th>Student Name</th>
                    <th>Classroom</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowIndex="rowIndex" let-student>
                <tr>
                    <td>
                        <p-tableCheckbox [value]="student"></p-tableCheckbox>
                    </td>
                    <td>
                        <div class="inline-block vertical-align-middle">
                            <img [src]="student.profileimg"
                                class="border-circle border-2 border-primary inline-block profileImage"
                                alt="Place image title" *ngIf="student.profileimg != undefined ; else noImageFound">
                            <ng-template #noImageFound>
                                <img class="inline-block profileImage border-circle border-2 border-primary"
                                    src="assets/layout/images/male.png" alt="Fallbackimage">
                            </ng-template>
                            <span class="ml-1 mt-1">
                                <a class="nameEmp" [routerLink]="['/myschool/student/profile/' + student.id]">
                                    {{student?.fullName}} </a>
                            </span>
                        </div>
                    </td>
                    <td>{{student?.roomName}}</td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="12" style="text-align: -webkit-center; font-weight: bold">
                        No records
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>


<p-dialog header="Sign-In" [(visible)]="displayStdsignIn" [modal]="true" showEffect="fade"
    [style]="{width: '35vw'}" [breakpoints]="{'960px': '75vw'}" [draggable]="false"
    [resizable]="false">
    <div class="col-12 flex align-items-center justify-content-center">
        <form [formGroup]="studentAttendanceForm">
            <div class="p-fluid">
                <div class="row">
                    <div class="field col">
                        <label for="password">Date</label>
                        <input pInputText id="Date" placeholder="Date" [ngModelOptions]="{standalone: true}"
                            [(ngModel)]="selectedDate" type="date" [disabled]="true" />
                    </div>

                    <div class="field col">
                        <label htmlFor="studentId">Sign-In Time</label>
                        <input pInputText id="time" type="time" pInputText
                            formControlName="signInTime" />
                    </div>
                </div>
            </div>
        </form>
    </div>
    <ng-template pTemplate="footer">
        <p-button icon="pi pi-times" (click)="displayStdsignIn=false" label="No" id="cancel"
            styleClass="p-button-secondary p-button-raised"></p-button>

        <p-button icon="pi pi-check" (click)="displayStdsignIn=false;submitSignIn();clicked = true" label="Yes, Sign In"
            styleClass="p-button-success p-button-raised" [disabled]="clicked"></p-button>

    </ng-template>
</p-dialog> -->


<div style="padding-top: 4px">
    <p-toast key="message"></p-toast>
    <p-steps [model]="items" [readonly]="true" [activeIndex]="activeIndex"
        (activeIndexChange)="onActiveIndexChange($event)"></p-steps>
</div>
<br />
<ng-container *ngIf="activeIndex === 0">

    <div>
        <div class="filter-container">
            <div class="filter-row-2 flex align-items-end gap-3">
                <!-- Select All Checkbox -->
                <div class="search-container">
                    <span class="p-input-icon-left">
                        <i class="pi pi-search"></i>
                        <input type="text" pInputText id="studentSearch" class="search-input"
                            placeholder="Search Students" (input)="filter()" [(ngModel)]="studentSearchInput"
                            appCapitalizeFirstLetter appNoLeadingSpace #studentSearch />
                    </span>
                </div>
                <!-- Select Tag Dropdown -->
                <p-dropdown appendTo="body" class="custom-dropdown-filter mr-2" optionLabel="name"
                    [(ngModel)]="selectedRoomId" filterBy="name" [options]="roomList"
                    optionValue="id" [filter]="true" [placeholder]="'Select Classroom'" (onChange)="filterRoom()"
                    #roomNameDropdown>
                </p-dropdown>
                <!-- Select Tag Dropdown -->
                <p-multiSelect appendTo="body" class="custom-dropdown-filter mr-2 " optionLabel="name"
                    [(ngModel)]="selectedTagId" filterBy="name" [options]="tagList" optionValue="id" [filter]="true"
                    placeholder="Select Tag" (onChange)="queryData()" #tagNameDropdown>
                </p-multiSelect>
                <!-- Select Status Dropdown -->
                <input pInputText id="date" class="border-gainsboro" [attr.max]="today" [(ngModel)]="selectedDate"
                    (ngModelChange)="queryData()" placeholder="Date" type="date" />

                <button pButton type="button" label="Clear All" (click)="onClear()" class="clear-btn"></button>
            </div>

            <div class="filter-row-3 flex align-items-end gap-3">
                <!-- <div class="student-profile-page__note--box">
                    <p class="p-2">Students will be refreshed on basis of date selection.Please select Date first.</p>
                </div> -->
            </div>
            <div class="filter-row-4 flex align-items-end gap-3">
                <div class="flex align-items-end gap-2">
                    <p-checkbox [binary]="true" [(ngModel)]="selectAllStudents"
                        (onChange)="toggleAllSelection();checkboxChanged()"></p-checkbox>
                    <label for="selectAll" class="mb-0">Select All</label>
                </div>
            </div>

        </div>
        <p-dataView [value]="studentList">
            <ng-template let-student pTemplate="listItem">
                <div class="student-item" [ngClass]="{ 'selected-student': student.selected }">
                    <img [src]="student.profileimg || 'assets/placeholder.png'" alt="Student Photo" class="profile-pic"
                        *ngIf="student.profileimg != null; else noImageFound" />
                    <ng-template #noImageFound>
                        <img class="profile-pic" src="assets/layout/images/male.png" alt="Fallbackimage" />
                    </ng-template>
                    <span class="student-name text-primary">{{ student.studentName }}</span>
                    <p-checkbox [binary]="true" [(ngModel)]="student.selected" [value]="student" (onChange)="
                toggleSelection(student);
                isSelected(student);
                checkboxChanged();">
                    </p-checkbox>
                </div>
            </ng-template>
            <ng-template pTemplate="empty">
                <div class="row" style="justify-content: center;">
                    <span class="text-primary text-center">
                        No result found
                    </span>
                </div>
            </ng-template>
            <ng-template pTemplate="footer">
                <div class="flex align-items-center justify-content-center gap-3">
                    <button pButton pRipple type="button" label="Cancel" class="p-button-outlined"
                        (click)="ref.close()"></button>
                    <button pButton pRipple label="Continue" id="save" (click)="complete()"></button>
                </div>
            </ng-template>
        </p-dataView>


    </div>
</ng-container>

<ng-container *ngIf="activeIndex === 1">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="selected-students-container">
                    <div class="student-card " *ngFor="let student of selectedStudentList">
                        <img *ngIf="student.profileimg; else noImageFound" [src]="student.profileimg"
                            alt="Student Photo" class="student-photo" />
                        <ng-template #noImageFound>
                            <img src="assets/layout/images/male.png" alt="Fallback Image" class="student-photo" />
                        </ng-template>

                        <!-- Student Name -->
                        <span class="student-name align-items-left">{{ student.studentName }}</span>

                        <!-- Delete Icon -->
                        <button class="delete-btn" (click)="onRemoveStud($event,student)">
                            <i class="pi pi-trash"></i>
                            <p-confirmPopup key="confirm2"></p-confirmPopup>

                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="container-fluid mb-2">
        <input pInputText  id="date" [attr.max]="today" *ngIf="!isAdminUserLogin" [(ngModel)]="selectedDate"
            (ngModelChange)="handleDateChange($event)" placeholder="Date" type="date" />
        <input pInputText id="time" type="time"  [(ngModel)]="signOutTime" pInputText class="ml-2" />
    </div>
    <div class="flex align-items-center justify-content-center gap-3">
        <button pButton pRipple type="button" label="Back" class="p-button-outlined" [disabled]="fromOverView"
            (click)="prevPage()"></button>
        <button pButton pRipple label="Save" id="save" [disabled]="selectedStudentList.length == 0 || buttonDisabled"
            (click)="onSave()"></button>
    </div>

</ng-container>
<!-- <div class="grid">
    <div class="col-12">
        <p-toolbar [style]="{
            'border-top-left-radius': '0px',
            'border-top-right-radius': '0px',
            'padding-bottom': '0px',
            'display': 'flex',
            'flex-wrap': 'wrap',
            'justify-content': 'space-between'
        }">
            <ng-template pTemplate="left">
                <div class="p-fluid">
                    <div class="p-formgrid grid p-3">
                        <div class="field">
                            <p-dropdown appendTo="body" class="custom-dropdown-one" optionLabel="fullName"
                                *authorityShow="['Attendance Daily (Full Access)']" [(ngModel)]="studentSearchID"
                                filterBy="fullName" [options]="studentSearchList" optionValue="id" (onFilter)="filterStudent($event)"
                                [filter]="true" [placeholder]="'Select Student'" (onChange)="searchStudent()" #studentDropdown>
                            </p-dropdown>
                        </div>
                        <div class="field textInp">
                            <input pInputText id="email2" [(ngModel)]="selectedDate" (ngModelChange)="handleDateChange($event)"
                                placeholder="Date" type="date" />
                        </div>
                        <div class="field">
                            <p-dropdown appendTo="body" class="custom-dropdown-one" optionLabel="name"
                                *authorityShow="['Attendance Daily (Full Access)']" [(ngModel)]="searchedListRoomId"
                                filterBy="name" [options]="roomsList" optionValue="id" (onFilter)="filterRoom($event)"
                                [filter]="true" [placeholder]="'Select Classroom'" (onChange)="searchStudent()" #roomNameDropdown>
                            </p-dropdown>
                        </div>
                        <div class="field icon-reset mt-1" *authorityHide="['Parent Is Private (Full Access)']">
                            <button type="button" pButton pRipple (click)="clearForm()" label="Clear"
                                class="p-button-secondary p-button-sm"></button>
                        </div>
                        <div class="field icon-reset mt-1" *authorityShow="['Parent Is Private (Full Access)']">
                            <button type="button" pButton pRipple (click)="clearForm()" label="Clear"
                                class="p-button-secondary p-button-sm"></button>
                        </div>
                    </div>
                </div>
            </ng-template>
        
            <ng-template pTemplate="right">
                <div class="assign-btn">
                    <button pButton pRipple label="Sign-Out" type="button" class="p-button-primary addbtn"
                        *authorityShow="['Attendance Daily (Full Access)','Parent Is Private (Full Access)']"
                        (click)="signOut()" icon="pi pi-sign-in" [disabled]="this.selectedStudents.length == 0"></button>
                </div>
            </ng-template>
        </p-toolbar>
        
        <div class="row gap-3" *ngIf="selectedStudents.length > 0"
            style="margin-left: 10px; margin-top: 10px; margin-bottom: 10px">
            <div *ngIf="selectedStudents.length > 0">
                {{
                selectedStudents.length === 1
                ? selectedStudents.length + " Student Selected"
                : selectedStudents.length + " Students Selected"
                }}
            </div>
        </div>

        <p-table #dt [value]="dailyAttendanceList" [(selection)]="selectedStudents" [lazy]="true"
            (onLazyLoad)="loadAttendance($event)" dataKey="id" [tableStyle]="{ 'min-width': '50rem' }" [paginator]="true"
            [rows]="10" [totalRecords]="pageContext.totalItems" [rowsPerPageOptions]="[10,25, 50]" [loading]="loading"
            [showCurrentPageReport]="true" currentPageReportTemplate="Showing {{
                    pageContext.totalItems > 0 ? first + 1 : first
                }} to {{ last }} of {{ pageContext.totalItems }} entries">
            <ng-template pTemplate="header">
                <tr>
                    <th style="width: 4rem">
                        <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                    </th>
                    <th>Student Name</th>
                    <th>Classroom</th>
                    <th>Sign In</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowIndex="rowIndex" let-student>
                <tr>
                    <td>
                        <p-tableCheckbox [value]="student"></p-tableCheckbox>
                    </td>
                    <td>
                        <div class="inline-block vertical-align-middle">
                            <img [src]="student.profileimg"
                                class="border-circle border-2 border-primary inline-block profileImage"
                                alt="Place image title" *ngIf="student.profileimg != undefined ; else noImageFound">
                            <ng-template #noImageFound>
                                <img class="inline-block profileImage border-circle border-2 border-primary"
                                    src="assets/layout/images/male.png" alt="Fallbackimage">
                            </ng-template>
                            <span class="ml-1 mt-1">
                                <a class="nameEmp" [routerLink]="['/myschool/student/profile/' + student.studentId]">
                                    {{student?.students?.fullName}} </a>
                            </span>
                        </div>
                    </td>
                    <td>{{student?.room?.name}}</td>
                    <td>{{student.signInTime | slice:0:5 }} {{ student.signInTime?.split(' ')[1] }}<br>
                        <span *ngIf="student.signInBy != null">By {{student.signInBy}}</span>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="12" style="text-align: -webkit-center; font-weight: bold">
                        No records
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>


<p-dialog header="Sign-Out" [(visible)]="displayStdsignIn" [modal]="true" showEffect="fade"
    [style]="{width: '35vw'}" [breakpoints]="{'960px': '75vw'}" [draggable]="false"
    [resizable]="false">
    <div class="col-12 flex align-items-center justify-content-center">
        <form [formGroup]="studentAttendanceForm">
            <div class="p-fluid">
                <div class="row">
                    <div class="field col">
                        <label for="password">Date</label>
                        <input pInputText id="Date" placeholder="Date" [ngModelOptions]="{standalone: true}"
                            [(ngModel)]="selectedDate" type="date" [disabled]="true" />
                    </div>

                    <div class="field col">
                        <label htmlFor="studentId">Sign-Out Time</label>
                        <input pInputText id="time" type="time" pInputText
                            formControlName="signOutTime" />
                    </div>
                </div>
            </div>
        </form>
    </div>
    <ng-template pTemplate="footer">
        <p-button icon="pi pi-times" (click)="displayStdsignIn=false;cancelDailog()" label="No" id="cancel"
            styleClass="p-button-secondary p-button-raised"></p-button>

        <p-button icon="pi pi-check" (click)="submitSignOut();clicked = true" label="Yes, Sign Out"
            styleClass="p-button-success p-button-raised" [disabled]="clicked"></p-button>

    </ng-template>
</p-dialog> -->